module.exports = __webpack_public_path__ + "static/preview-piclife-3643b81f64182408c0d2d5227dc381ae.png";